<template>
  <div class="layout">
    <div class="error-403">
      <img src="images/err-403.png" class="error-403-img" />
      <div class="error-403-text">Доступ запрещен. У вас недостаточно прав</div>
      <div class="error-403-link">
        Обратитесь к администратору системы — <a href="mailto:v@doxsw.com">v@doxsw.com</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "error-403",
};
</script>

<style lang="scss" scoped>
.error-403 {
  overflow: hidden;
  background-position: top center;
  background-repeat: no-repeat;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 30px;

  &-img {
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }

  &-text {
    padding-top: 38px;
    font-size: 24px;
    margin-bottom: 20px;
    font-weight: 700;

    @media screen and (max-width: 500px) {
      padding-top: 30px;
      font-size: 22px;
    }
  }
}
</style>
